/** Only known local Support destinations survive sign-in; never accept arbitrary redirect URLs. */
export function supportReturnPath(value: string | null): string | null {
  return value && /^\/support(?:\?(?:new=1|ticket=[a-zA-Z0-9-]{1,80}))?$/.test(value) ? value : null;
}
export function adminSupportReturnPath(value: string | null): string | null {
  return value && /^\/admin\?tab=support(?:&ticket=[a-zA-Z0-9-]{1,80})?$/.test(value) ? value : null;
}
